// @vendors
const get = require('lodash/object/get');
// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { getFormattedLanguage } = require('core/i18n').i18n;
import { getCCOfficeChannel } from 'utilities/contactCenter/printerHelper';

// @constants
const actionTypes = require('constants/actionTypes');
import { API_CHANNEL } from 'constants/index';

// @ actions
const { populateContractDescriptions } = require('actions/brokerPositionsValuesContracts');
const { bannerShow } = require('actions/bannerUpdate');
const { setGeneralViewData, setSummarizationData } = require('actions/myWallet');

const fetchSuccess = (response) => (dispatch, getState) => {
    dispatch({
        type: actionTypes.CW_GET_MY_INVESTMENTS_SUCCESS,
        payload: {
            data: get(response, 'productos'),
            actives: get(response, 'tiposRenta'),
            contracts: get(response, 'contratos', {}),
            summarizedInvestedCap: get(response, 'sumarizacion.consolidado.capitalInvertido.importeEur.importe'),
            summarizedProfitability: get(response, 'sumarizacion.consolidado.rentabilidad.importeEur.importe'),
            summarizedValor: get(response, 'sumarizacion.consolidado.valor.importeEur.importe'),
            profitablePercentage: get(response, 'sumarizacion.consolidado.porcentajeRentabilidad.importeEur.importe'),
            distribucionPorRenta: get(response, 'distribucionPorRenta'),
            fundsList: [],
            plansList: [],
            futuresList: [],
            valuesList: [],
            cuentas: getState().brokerWallets.toJSON()
        }
    });
};

const fetchSuccessRobo = (response) => (dispatch, getState) => {
    dispatch({
        type: actionTypes.BROKER_GET_MY_INVESTMENTS_SUCCESS,
        payload: {
            data: get(response, 'productos'),
            accounts: getState().accounts.get('byId'),
            actives: get(response, 'tiposRenta'),
            contracts: get(response, 'contratos', {}),
            summarizedInvestedCap: get(response, 'sumarizacion.consolidado.capitalInvertido.importeEur.importe'),
            summarizedProfitability: get(response, 'sumarizacion.consolidado.rentabilidad.importeEur.importe'),
            summarizedValor: get(response, 'sumarizacion.consolidado.valor.importeEur.importe'),
            profitablePercentage: get(response, 'sumarizacion.consolidado.porcentajeRentabilidad.importeEur.importe'),
            distribucionPorRenta: get(response, 'distribucionPorRenta'),
            fundsList: [],
            plansList: [],
            futuresList: [],
            valuesList: [],
            cuentas: getState().brokerWallets.toJSON(),
            roboAdvisor: response.roboadvisor,
            patrimony: response.patrimony,
            roboAccount: response.cuentas,
            canHireRoboWithTransfer: response.canHireRoboWithTransfer
        }
    });
};

const fetchFailure = (error) => {
    return {
        type: actionTypes.CW_GET_MY_INVESTMENTS_FAILURE,
        payload: { error }
    };
};

const fetchMyInvestments = (idPortfolioAccount) => (dispatch, getState) => {
    const immBrokerCustomWalletInvestments = getState().brokerCustomWalletInvestments;
    let fetchMyInvestmentsPromise;

    if((!immBrokerCustomWalletInvestments.get('fetchSuccess') || immBrokerCustomWalletInvestments.get('isOutdated')) && !immBrokerCustomWalletInvestments.get('isFetching')) {

        const url = apiURLBuilder.getURL('myMoneyPgValores');
        let requestData = {
             header: {
                version: 3,
                'Accept-Language': getFormattedLanguage()
             },
             query:{
                prod: 'PLANES_FONDOS_Y_VALORES',
                portfolioAccountId: idPortfolioAccount,
                stockRights: true
             }
        };
        dispatch({
            type: actionTypes.CW_GET_MY_INVESTMENTS_REQUEST,
            payload: {}
        });
        dispatch(bannerShow());
        fetchMyInvestmentsPromise = APIGet(dispatch, url, requestData).then(
            response => {
                dispatch(fetchSuccess(response));
                dispatch(setSummarizationData(response));
                dispatch(populateContractDescriptions());
                dispatch(setGeneralViewData(response));
                dispatch(fetchSuccessRobo(response));
                dispatch(getContributionsList())
            },
            error => dispatch(fetchFailure(error))
        );
    }

    return fetchMyInvestmentsPromise;
};

const getContributionsList = () => (dispatch, getState) => {
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const immContracts = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).toJS();
    const contractList = immContracts.map(contract => ({
      contractCode: contract.contractNumber,
      productId: contract.product,
    }));
  
    const url = apiURLBuilder.getURL('brokerGetRecurringTransfersList');
    const requestData = {
      query: {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contracts: contractList,
      },
      header: {
        version: 2,
      },
    };
  
   dispatch(requestContributionsList());
  
   APIPost(dispatch, url, requestData).then(
      response => dispatch(fetchContributionListSuccess(response)),
      error => dispatch(fetchContributionListError(error))
    ).catch(error => dispatch(fetchContributionListError(error)));
  
  };
  
  const requestContributionsList = () => (dispatch) => {
      dispatch({
          type: actionTypes.CW_BROKER_GET_CONTRIBUTION_LIST_REQUEST,
      });
  };
  
  const fetchContributionListSuccess = (response) => (dispatch) => {
      dispatch({
          type: actionTypes.CW_BROKER_GET_CONTRIBUTION_LIST_SUCCESS,
          payload: response,
      });
  };
  const fetchContributionListError = (error) => (dispatch) => {
      dispatch({
          type: actionTypes.CW_BROKER_GET_CONTRIBUTION_LIST_FAILURE,
          payload: error,
      });
  };

const outdateMyInvestments = () => (dispatch) => {
    return dispatch({
        type: actionTypes.CW_GET_MY_INVESTMENTS_SET_OUTDATED
    });
};

module.exports = {
    fetchSuccess,
    fetchMyInvestments,
    outdateMyInvestments
};
